import Vue from 'vue'
import axios from 'axios'
import {vuexOidcCreateStoreModule} from 'vuex-oidc'
import {oidcSettings} from '../config/oidc'
import pyChar from 'js-pinyin'
import store from '..'
import qs from 'qs'
import manageSearchGuide from './manage'

const state = {
    userId: '',
    loadingDataStart: false,
    targetMessage: '',
    isCanFresh: true,
    apiMap: {
        'appall': {
            url: 'me/apps',
            query: '',
        },
        'todo': {
            url: 'me/tasks/todo',
            query: ''
        },
        'apply': {
            url: 'me/tasks/todo',
            query: ''
        },
        'doing': {
            url: 'me/processes/doing',
            query: {
                limit: 10,
                start: 0,
                keyword: '',
            },
        },
        'done': {
            url: 'me/processes/done',
            query: {
                limit: 10,
                start: 0,
                keyword: '',
            }
        },
        'flow_cc': {
            url: 'me/processes/cc',
            query: {
                limit: 10,
                start: 0,
                unread: true,
                keyword: '',
            },
        }
    },
    dataSource: {
        'todo': [],
        'apply': [],
        'doing': [],
        'done': [],
        'flow_cc': []
    },
    dataLength: {
        'todo': 0,
        'apply': 0,
        'done': 0,
        'doing': 0,
        'flow_cc': 0,
        'cc': 0, // 未读的抄送数量
        'medoing': 0 // 进行中属于自己那方的数量
    },
    appList: [],
    guideList: [],
    filterGuideList: [],
    statsRes: {},
    recommends: [],
    tags: [], // 服务分类
    department: [], // 服务部门
    object: [], // 服务对象
    tagApps: [],
    process_pass: [],
    favorites: [],
    favoriteApps: [],
    zm: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
    highlights: [],
    appQuery: {
        seq: '',
        tag: '',
        dep: '',
        obj: ''
    },
    userInfos: {}
}

Vue.filter('noNum', function (sortTag) {    // msg 为固定的参数 即是你需要过滤的数据
    let tags = sortTag && sortTag.split("-");
    if (parseInt(tags && tags[0]) >= 0) {
        return sortTag.replace(tags[0] + '-', '');
    } else {
        return sortTag;
    }
});

Vue.filter('noNum2', function (sortTag) {    // msg 为固定的参数 即是你需要过滤的数据
    let tags = sortTag.split("-");
    let res = '';
    if (parseInt(tags[0]) >= 0) {
        res = sortTag.replace(tags[0] + '-', '');
    } else {
        res = sortTag;
    }
    return res.slice(0, 2);
});

const getters = {
    getAuth: () => store.state.oidcStore,
    getEmail: () => store.state.oidcStore.user.email,
    getUserInfo: () => store.state.userInfos,
    getId: () => store.state.userInfos.id,
    getAppList: state => state.appList,
    getRecommends: state => state.recommends,
    getTags: state => state.tags,
    getDeps: state => state.department,
    getObjs: state => state.object,
    getTagApps: state => state.tagApps, // 搜索过滤后的app
    getGuideList: state => state.guideList,
    getFilterGuideList: state => state.filterGuideList, // 搜索过滤后的guide
    getHighLights: state => state.highlights,
    getFavorites: state => state.favorites,
    getFavoriteApps: state => state.favoriteApps,
    getProcess: state => state.process_pass,
    getState: state => state,
    getDataSourceMap: state => state.apiMap,
    getDataSource: state => state.dataSource,
    getDataLength: state => state.dataLength
}
const actions = {
    async fetchAppList({commit, state, dispatch}, {filterApps, keyword = ''}) {
        await axios.post(`${window.commonApi.TASKCENTER_URL}/manage/searchGuide?keyword=${keyword}`).then(res => {
            if (res.data.code == 200) {
                let appList = res.data.t && res.data.t.appList && res.data.t.appList.map(item => {
                    return {...item.hit, shouzimu: pyChar.getFullChars(item.hit.name).toUpperCase().slice(0, 1)}
                });
                if (filterApps) appList = filterApps(appList);
                let guideList = res.data.t && res.data.t.guideList && res.data.t.guideList.map(item => {
                    return {...item.hit}
                });
                state.appList = appList;
                state.guideList = guideList;
                dispatch('guideSearch', {keyword: ''})
                dispatch('favoriteGet');
                dispatch('getStatus', appList);
                dispatch('metodoLength');
                dispatch('ccsLength');
                commit('updateAppList');
                commit('updateAppAll');
            }
        }).catch(error => {
            console.log(error);
        });
    },

    favoriteGet({commit}) {
        axios.get(`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps`).then(res => {
            if (res.data.errno == 0) {
                let id = res.data.entities[0].id, favorites = res.data.entities[0].FavoriteApps;
                state.userId = id;
                state.favorites = favorites;
                commit('favoriteReset', favorites);
            }
        }).catch(error => {
            console.log(error);
        });
    },

    metodoLength({state, dispatch, commit}) {
        commit('loadingData', true);
        let mes = store.state.userInfos;
        axios.get(`${window.commonApi.INFOPLUS_URL}/me/tasks/todo`).then(res => {
            if (res.data.errno == 0) {
                if (res.data && res.data.entities.length > 0) {
                    state.dataSource['todo'] = res.data.entities;
                    let isMyTodo = res.data.entities.filter(item => item.process.owner.name == mes.name);
                    let noMyTodo = res.data.entities.filter(item => item.process.owner.name !== mes.name);
                    state.dataLength.todo = isMyTodo.length;
                    state.dataLength.apply = noMyTodo.length;
                    commit('loadingData', false);
                }else {
                    commit('loadingData', false);
                }
            }
        }).catch(error => {
            console.log(error);
            commit('loadingData', false);
        });
    },

    ccsLength({dispatch, commit}) {
        let params = {
            limit: 1,
            start: 0,
            unread: true,
        }
        axios.get(`${window.commonApi.INFOPLUS_URL}/me/processes/cc`, {params}).then(res => {
            if (res.data.errno == 0) {
                state.dataLength.cc = res.data.total;
            }
        }).catch(error => {
            console.log(error);
        });
    },

    medoingsLength({dispatch, commit}) {
        let params = {
            limit: 1,
            start: 0,
            sep: false,
        }
        axios.get(`${window.commonApi.INFOPLUS_URL}/${state.apiMap['doing'].url}`, {params}).then(res => {
            if (res.data.errno == 0) {
                commit('medoingsNum', {'num': res.data.total});
            }
        }).catch(error => {
            console.log(error);
        });
    },

    getStatus({state}, items) {
        axios.get(`${window.commonApi.INFOPLUS_URL}/stats/apps`).then(res => {
            if (res.data.errno == 0) {
                let stats = res.data.entities;
                state.statsRes = res.data;
                state.appList = items.map(item => {
                    let item2 = stats.filter(a => a.id === item.id);
                    item.processCounters = item2[0] ? item2[0].processCounters.completed : 0;
                    return item;
                })
            }
        }).catch(error => {
            console.log(error);
        });
    },

    guideSearch({state}, {keyword}) {
        if (keyword !== '') {
            state.filterGuideList = state.guideList.filter(item => item.title.indexOf(keyword) > -1);
        } else {
            state.filterGuideList = state.guideList;
        }
    },

    //首页和全部事项的搜索，tag
    updateQuery({commit, state}, {seq, tag, dep, obj}) {
        state.appQuery = {seq: '', tag: '', dep: '', obj: ''};
        state.appQuery.seq = seq || state.appQuery.seq;
        state.appQuery.tag = tag || state.appQuery.tag;
        state.appQuery.dep = dep || state.appQuery.dep;
        state.appQuery.obj = obj || state.appQuery.obj;
        if (seq === 'all') {
            state.appQuery.seq = '';
        }
        if (tag === 'all') {
            state.appQuery.tag = '';
        }
        if (dep === 'all') {
            state.appQuery.dep = '';
        }
        if (obj === 'all') {
            state.appQuery.obj = '';
        }
        commit('updateAppAll');
    },

    //抄送变为已读
    async flow_read({dispatch, state, commit}, {ids, unread}) {
        let ccs = ids.split(",");
        for (let i in ccs) {
            await axios.post(`${window.commonApi.INFOPLUS_URL}/process/${ccs[i]}`, qs.stringify({"action": "read"})).then(res => {
                if (res.data.errno == 0) {
                    commit('Message', `success#已标记为已读#${new Date()}`);
                    dispatch('resetData', {dataName: 'flow_cc'});
                }
            }).catch(error => {
                commit('Message', `error#${error.message}`);
            })
        }
    },

    //评分
    Rated({state, dispatch, commit}, {id, rating, review}) {
        axios.post(`${window.commonApi.INFOPLUS_URL}/process/${id}`, qs.stringify({
            "action": "rate",
            "rating": rating,
            "remark": review
        })).then(res => {
            if (res.data.errno == 0) {
                commit('Message', `success#评分成功#${new Date()}`);
                dispatch('resetData', {
                    dataName: 'done'
                });
            }
        }).catch(error => {
            console.log(error);
            commit('Message', `error#${error.message}`);
        })
    },

    //需要批量办理时候的多选框
    process_push({commit, state}, {id, isok, clear}) {
        if (isok) {
            state.process_pass.push(id);
        } else {
            state.process_pass = state.process_pass.join(',').replace(`${id}`, '').split(',').filter(item => item);
        }
        if (clear) state.process_pass = [];
        state.process_pass = Array.from(new Set(state.process_pass));
    },

    //批量办理
    process_many({dispatch, state}, actionId) {
        state.process_pass.map(id => {
            axios.post(`${window.commonApi.INFOPLUS_URL}/task/${id}`, qs.stringify({"actionId": actionId})).then(res => {
                if (res.data.errno == 0) {
                    dispatch('resetData', {dataName: 'todo'});
                }
            }).catch(error => {
                console.log(error);
            })
        })
    },

    //单独一个快捷办理
    process_one({dispatch, state}, {actionId, id}) {
        axios.post(`${window.commonApi.INFOPLUS_URL}/task/${id}`, qs.stringify({"actionId": actionId})).then(res => {
            if (res.data.errno == 0) {
                dispatch('resetData', {dataName: 'todo'});
            }
        }).catch(error => {
            console.log(error);
        });
    },

    //获取流程细节
    processTask({commit, state}, id) {
        axios.get(`${window.commonApi.INFOPLUS_URL}/process/${id}`).then(res => {
            if (res.data.errno == 0) {
                return res.data.entities[0];
            }
        }).catch(error => {
            console.log(error);
        })
    },

    //本地存储置顶，逻辑
    highChange({commit, state}) {
        let user = state.oidcStore.user.email;
        let highlights = localStorage.getItem(`${user}_top`).split(',').filter(item => item);
        commit('HighLightReset', highlights)
    },

    //点击爱心按钮,逻辑
    favoriteNow({commit}, {id, method}) {
        if (method === 'put') {
            axios.put(`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps/${id}`).then(res => {
                if (res.data.errno == 0) {
                    let items = res.data.entities[0].FavoriteApps;
                    commit('favoriteReset', items);
                } else {
                    sessionStorage.setItem('error_res_now', res.data.error);
                }
            }).catch(error => {
                console.log(error);
                sessionStorage.setItem('error_res_now', error);
            })
        } else {
            axios.delete(`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps/${id}`).then(res => {
                if (res.data.errno == 0) {
                    let items = res.data.entities[0].FavoriteApps;
                    commit('favoriteReset', items)
                }
            }).catch(error => {
                console.log(error);
            })
        }
    },

    //将参数原始化
    ClearQ({commit, state, dispatch}, {dataName}) {
        let origin_query = {
            limit: 10,
            start: 0,
            unread: true,
            keyword: '',
            lastUpdate: null
        };
        let origin = state.apiMap[dataName];
        if (origin && origin.query) {
            for (let key in origin_query) {
                if (typeof origin.query !== "string" && origin.query.hasOwnProperty(key)) {
                    origin.query[key] = origin_query[key];
                }
            }
            state.apiMap[dataName].query = origin.query;
        }
        dispatch('resetData', {dataName, 'query': origin.query});
    },

    //添加后来的参数，如timestamp
    AddQ({state, dispatch}, {dataName, property, val}) {
        if (!state.apiMap[dataName].query.hasOwnProperty(property)) {
            state.apiMap[dataName].query[property] = val;
            dispatch('resetData', {dataName, query: state.apiMap[dataName].query});
        } else {
            dispatch('SearchQ', {key: dataName, property, val});
        }
    },

    //调用接口的搜索
    SearchQ({dispatch, commit}, {key, property, val, limitRefresh}) {
        //limitRefresh限制刷新
        let str1 = JSON.stringify(state.apiMap[key].query);
        state.apiMap[key].query[property] = val;
        let str2 = JSON.stringify(state.apiMap[key].query);
        if (property != 'start' && property != 'limit') {
            state.apiMap[key].query['start'] = 0;
        }
        let query = state.apiMap[key].query;
        let dataName = key;
        //更改参数
        commit('ChangeQ', {dataName, query});
        if (str1 != str2 && !limitRefresh) {
            dispatch('resetData', {dataName, query});
        }
    },

    async resetData({commit, state, dispatch}, {dataName, query}) {
        commit('loadingData', true);
        let url = state.apiMap[dataName].url;
        let params = Object.assign({}, query || state.apiMap[dataName].query);
        if (params.hasOwnProperty('unread') && !params.unread) delete params.unread;
        if (params.hasOwnProperty('keyword') && !params.keyword) delete params.keyword;
        if (params.hasOwnProperty('timestamps') && !params.timestamps) delete params.timestamps;
        if (params.hasOwnProperty('lastUpdate') && !params.lastUpdate) delete params.lastUpdate;
        await axios.get(`${window.commonApi.INFOPLUS_URL}/${url}`, {params}).then(res => {
            if (res.data.errno == 0) {
                let items = res.data.entities;
                let total = res.data.total;
                commit('dataGet', {items, total, dataName});
                console.log(dataName + '初始化成功！');
                commit('loadingData', false);
                switch (dataName) {
                    case 'todo':
                        dispatch('highChange');
                        break;
                    case 'flow_cc':
                        dispatch('ccsLength');
                        break;
                }
            } else {
                commit('loadingData', false);
            }
        }).catch(error => {
            console.log(error);
            commit('loadingData', false);
        });
        dispatch('metodoLength');
    }
}
const mutations = {
    updateAppList(state) {
        let appList = state.appList;
        let recommends = [], tags = [], department = [], object = [];
        if (appList.length > 0) {
            department = appList.map(item => item.tags && item.tags.split(",").length > 0 && item.tags.split(",")[0]);
            tags = appList.map(item => item.tags && item.tags.split(",").length > 1 && item.tags.split(",")[1]);
            object = appList.map(item => item.tags && item.tags.split(",").length > 2 && item.tags.split(",")[2]);
            recommends = appList.filter(item => item.recommend && item.recommend > 0);
            department = Array.from(new Set(department)).sort();
            tags = Array.from(new Set(tags)).sort();
            object = Array.from(new Set(object)).sort();
        }
        recommends.forEach(item => {
            if (!item.recommend) {
                item.recommend = 0;
            }
        })
        state.recommends = recommends.sort((a, b) => b.recommend - a.recommend);
        state.department = department.sort();
        state.tags = tags.sort();
        state.object = object.sort();
    },

    updateAppAll(state, appList) {
        if (appList) {
            state.appList = appList;
        }
        let all_apps = state.appList;
        let filtered_appsList = [];
        for (let key in all_apps) {
            let objNow = all_apps[key];
            objNow.department = objNow.department || '';
            let limit = [false, false, false, false];
            if (state.appQuery.seq && objNow.name.indexOf(state.appQuery.seq) === -1) {
                limit[0] = true;
            }
            if (state.appQuery.dep && objNow.tags.split(',').length > 0 && objNow.tags.split(',')[0].indexOf(state.appQuery.dep) === -1) {
                limit[1] = true;
            }
            if (state.appQuery.tag && objNow.tags.split(',').length > 1 && objNow.tags.split(',')[1].indexOf(state.appQuery.tag) === -1) {
                limit[2] = true;
            }
            if (state.appQuery.obj && objNow.tags.split(',').length > 2 && objNow.tags.split(',')[2].indexOf(state.appQuery.obj) === -1) {
                limit[3] = true;
            }
            if (limit.indexOf(true) === -1) {
                filtered_appsList.push(objNow);
            }
        }
        if (state.appQuery.seq == '' && state.appQuery.dep == '' && state.appQuery.tag == '' && state.appQuery.obj == '') {
            state.tagApps = all_apps;
        } else {
            state.tagApps = filtered_appsList;
        }
        state.loadingDataStart = false;
    },

    CcthingsReset(state, {items, total}) {
        let sort_ccthings = items.sort((a, b) => {
            if (a.read && b.read) {
                return 0;
            } else if (a.read && !b.read) {
                return -1;
            } else {
                return 1;
            }
        });
        state.ccthings.total = total;
        state.ccthings.val = sort_ccthings;
    },

    favoriteReset(state, favorites) {
        state.favorites = favorites;
        state.favoriteApps = state.favorites.map(item1 => state.appList.filter(item2 => item2.id == item1)[0]).filter(exit => exit);
    },

    medoingsNum(state, {num}) {
        state.dataLength.medoing = num;
    },

    wtReset(state, {items, wt_owner}) {
        state.wtThings[wt_owner] = items;
    },

    HighLightReset(state, highlights) {
        state.highlights = highlights.filter(item => item);
    },

    dataGet(state, {items, total, dataName}) {
        state.dataSource[dataName] = items;
        state.dataLength[dataName] = total;
    },

    ChangeQ(state, {dataName, query}) {
        state.apiMap[dataName].query = Object.assign({}, query);
    },

    //骨架屏
    loadingData(state, load_bool) {
        state.loadingDataStart = load_bool;
    },

    //传递消息
    Message(state, word) {
        state.targetMessage = word;
    },

    //长链接
    toIsCanFresh(state, bool) {
        state.isCanFresh = bool;
    },

    //profile问题
    setUserInfo(state, obj) {
        state.userInfos = Object.assign({}, obj);
    }
}

const modules = {
    manageSearchGuide: manageSearchGuide,
    oidcStore: vuexOidcCreateStoreModule(
        oidcSettings,
        {
            namespaced: true,
            dispatchEventsOnWindow: true
        },
        {
            userLoaded: (user) => console.log('OIDC user is loaded:', user),
            userUnloaded: () => console.log('OIDC user is unloaded'),
            accessTokenExpiring: () => console.log('Access token will expire'),
            accessTokenExpired: () => console.log('Access token did expire'),
            silentRenewError: () => console.log('OIDC user is unloaded'),
            userSignedOut: () => console.log('OIDC user is signed out'),
            oidcError: (payload) => console.log('OIDC error', payload)
        }
    )
}

export default {
    modules,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js